function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "voice_svg__a",
  x: 1.688,
  y: 8.143,
  width: 26.571,
  height: 21.896,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "voice_svg__c",
  x: 3.247,
  y: 2.688,
  width: 23.455,
  height: 23.455,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "voice_svg__e",
  x: 19.948,
  y: 11.377,
  width: 28.675,
  height: 29.455,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  result: "f"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "f"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "voice_svg__g",
  x: 11.377,
  y: 9.818,
  width: 34.13,
  height: 32.571,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  result: "h"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "h"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".voice_svg__b{fill:#383d5a}.voice_svg__c,.voice_svg__j{fill:none}.voice_svg__c,.voice_svg__e{stroke:#1b1c26}.voice_svg__c{stroke-linecap:round}.voice_svg__c,.voice_svg__e{stroke-width:2px}.voice_svg__e,.voice_svg__f{fill:#ff6c6c}.voice_svg__g{fill:#1b1c26}.voice_svg__i{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.896 7.013)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__b",
  d: "M23.188 33.507h5.832l2.335 13.837h-10.5z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "voice_svg__b",
  width: 51.429,
  height: 41.299,
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__c",
  d: "M.987 35.655h49.716M-.971 19.292h16m10.42 16.363v-7.32m10.864-9.043h16.883m-27.747-9.044V-1.48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.416 47.344h23.308",
  stroke: "#383d5a",
  strokeWidth: 2,
  strokeLinecap: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__c",
  d: "M25.603 39.588h.039"
}), /*#__PURE__*/React.createElement("g", {
  className: "voice_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__i",
  d: "M10.298 10.13h1.559a3.506 3.506 0 013.506 3.506.39.39 0 01-.39.39H7.182a.39.39 0 01-.39-.39 3.506 3.506 0 013.506-3.506z"
}), /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__j",
  d: "M10.705 9.13h.745a4.913 4.913 0 014.913 4.913.983.983 0 01-.983.983H6.775a.983.983 0 01-.983-.983 4.913 4.913 0 014.913-4.913z"
})), /*#__PURE__*/React.createElement("g", {
  className: "voice_svg__e",
  transform: "translate(8.35 4.675)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__i",
  cx: 2.727,
  cy: 2.727,
  r: 2.727
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__j",
  cx: 2.727,
  cy: 2.727,
  r: 3.727
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#voice_svg__a)",
  transform: "translate(-3.898 -7.015)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M14.196 17.14h1.559a3.506 3.506 0 013.506 3.506.39.39 0 01-.39.39H11.08a.39.39 0 01-.39-.39 3.506 3.506 0 013.506-3.506z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#voice_svg__c)",
  transform: "translate(-3.898 -7.015)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__f",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(12.25 11.69)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.792 22.597)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__g",
  d: "M2.506 5.455h1.559a3.506 3.506 0 013.506 3.506.39.39 0 01-.39.39H-.61a.39.39 0 01-.39-.39 3.506 3.506 0 013.506-3.506z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(.558)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.065 4.675)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__g",
  d: "M3.506 5.455h1.559a3.506 3.506 0 013.506 3.506.39.39 0 01-.39.39H.39a.39.39 0 01-.39-.39 3.506 3.506 0 013.506-3.506z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(1.558)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.065 22.597)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__g",
  d: "M3.506 5.455h1.559a3.506 3.506 0 013.506 3.506.39.39 0 01-.39.39H.39a.39.39 0 01-.39-.39 3.506 3.506 0 013.506-3.506z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "voice_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(1.558)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__i",
  d: "M31.948 22.819h-.123l-.12-.03-3.021-.756a1.782 1.782 0 01-1.632-1.773v-2.338c0-.931.72-1.698 1.632-1.773l3.022-.755.119-.03h.123c.981 0 1.78.798 1.78 1.78v3.895c0 .981-.799 1.78-1.78 1.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.948 16.364l-3.117.78a.78.78 0 00-.779.778v2.338c0 .43.349.78.78.78l3.116.779a.78.78 0 00.78-.78v-3.896a.78.78 0 00-.78-.779m-.246-2h.246a2.782 2.782 0 012.78 2.78v3.895a2.782 2.782 0 01-2.78 2.78h-.246l-.239-.06-2.95-.738a2.783 2.783 0 01-2.461-2.76v-2.339a2.783 2.783 0 012.46-2.76l2.951-.738.239-.06z",
  fill: "#1b1c26"
})), /*#__PURE__*/React.createElement("g", {
  className: "voice_svg__e",
  transform: "translate(19.481 14.805)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "voice_svg__i",
  width: 10.13,
  height: 8.571,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  className: "voice_svg__j",
  x: -1,
  y: -1,
  width: 12.13,
  height: 10.571,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.9 -7.01)",
  filter: "url(#voice_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  className: "voice_svg__f",
  d: "M32.729 24.159l3.121-.779a.779.779 0 01.779.779v3.9a.779.779 0 01-.779.779l-3.121-.783a.779.779 0 01-.779-.775v-2.342a.779.779 0 01.779-.779z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.9 -7.01)",
  filter: "url(#voice_svg__g)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "voice_svg__f",
  width: 10.13,
  height: 8.571,
  rx: 2,
  transform: "translate(23.38 21.82)"
})));

var SvgVoice = function SvgVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgVoice as ReactComponent };